<template>
  <header class="flex flex-col items-center justify-center bg-cover bg-center bg-no-repeat" :style="{ backgroundImage: 'url(' + require(`@/assets/background.jpg`) + ')' }">
    <div class="w-full max-h-full h-screen">
      <div class="pt-0 flex flex-col items-center max-h-full">
        <img class="py-10 max-h-full object-contain" src="@/assets/logo.png"/>

        <div class="p-10 text-white text-center">
          <button @click="scrollToForm"
            class="mt-10 px-6 py-4 bg-white border-white hover:bg-black text-xl text-black font-semibold hover:text-white border rounded">
            <i class="pi pi-check mr-2"></i>ACREDITARME
          </button>
          <!--button @click="bajarCredencialPorDni"
            class="ml-4 mt-4 px-4 py-2 bg-transparent border-white hover:bg-slate-500 text-white font-semibold hover:text-white border rounded">
            <i class="pi pi-check mr-2"></i>YA ME ACREDITÉ
          </button-->

        </div>

      </div>
    </div>
  </header>
</template>

<script lang="ts">
import VueScrollTo from 'vue-scrollto';
import Swal from 'sweetalert2'

import suiteService, { Acreditado } from 'qreventos-suite/services';
import suiteConfig from '@/services/suite.config';

export default {
  name: 'HeaderSection',
  methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
    bajarCredencialPorDni() {
      
      Swal.fire({
        title: 'Ingresá tu DNI',
        input: 'text',
        icon: 'question',
        showCancelButton: true,
        cancelButtonText: 'CANCELAR',
        confirmButtonText: 'BAJAR MI CREDENCIAL',
        showLoaderOnConfirm: true,
        preConfirm: async (dni:any) => {
          try {
            const acreditadoPorDni:Acreditado = await suiteService.findAcreditadoByDni(suiteConfig.evento, suiteConfig.token, dni);
            if (!acreditadoPorDni) {
              Swal.showValidationMessage("El DNI ingresado no existe");
            } else {
            window.location.href = "https://apps.qreventos.com/credencial/getCredencial?credencial=128&evento=299&hash=" + acreditadoPorDni.hash + "&pdf=false";
            }
          } catch (error) {
            Swal.showValidationMessage("Error inesperado : "+error);
          }
        }
      });
    }
  },
}

</script>